// Customize this 'myform.js' script and add it to your JS bundle.
// Then import it with 'import MyForm from "./myform.js"'.
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React from "react";
import SuccessMsg from "./success-msg"
import ErrorMsg from "./error-msg"

export default class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    return (
      <form
        onSubmit={this.submitForm}
        action="https://formspree.io/f/xrgovkdw"
        method="POST"
        className="w-full max-w-lg mx-auto"
      >
        <div className="flex flex-wrap -mx-3 mb-6">
          <div className="w-full px-3">
            <input
            type="text"
            name="name"
            placeholder="Name"
            className="appearance-none bg-white block border border-gray-300 focus:border-8 focus:ring focus:ring-blue-500 focus:outline-none leading-tight mb-3 px-4 py-3 rounded text-gray-700 w-full"
            autoComplete="off"
            />
         </div>
          <div className="w-full px-3">
            <input
            type="email"
            name="email"
            placeholder="Email"
            className="appearance-none bg-white block border border-gray-300 focus:border-8 focus:ring focus:ring-blue-500 focus:outline-none leading-tight mb-3 px-4 py-3 rounded text-gray-700 w-full"
            autoComplete="off"
            />
         </div>
         <div className="w-full px-3">
            <textarea
              name="message"
              className="appearance-none bg-white block border border-gray-300 focus:border-8 focus:ring focus:ring-blue-500 focus:outline-none leading-tight mb-3 px-4 py-3 rounded text-gray-700 w-full"
              rows="4"
              placeholder="Your Message."
              autoComplete="off"
            ></textarea>
         </div>
        </div>
        {status === "SUCCESS" ? <SuccessMsg><div className="font-bold text-xl">Your message was sent successfully!</div></SuccessMsg> : <button className="bg-blue-600 px-10 py-3 rounded text-white hover:bg-blue-500 float-right">Send</button>}
        {status === "ERROR" && <ErrorMsg><p className="font-bold">Be Warned</p><p>Something not ideal might be happening.</p></ErrorMsg>}
      </form>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}
